import { dealerContactLink } from '@/state/config.js';

/** Renders nothing when the account configured neither a website nor a phone. */
export function DealerContactLink() {
  const contact = dealerContactLink.value;
  if (contact === null) return null;

  return (
    <a
      className="sm-type-body sm-link"
      href={contact.href}
      {...(contact.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      Contact your dealer
    </a>
  );
}
